import {faPenToSquare} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import Button from 'components/Button';
import EditControls from 'components/Edit/EditControls';
import BooleanCell from 'components/Table/Cell/Boolean';
import DateCell from 'components/Table/Cell/Date';
import {BooleanCheckboxFilter} from 'components/Table/Filter/Boolean';
import TextFilter from 'components/Table/Filter/Text';
import VirtualizedTable from 'components/Table/Virtualized';
import {fixedColumnStyle} from 'components/Table/columnHelpers';
import {techStackColumns} from 'pages/public/companyTechStack/List';


export default function UserList({users, onEdit}) {

  const renderControlCell = ({value}) => (
    <EditControls className="editControls--inline">
      <Button
        key={`edit${value}`}
        data-id={value}
        actionHandler={onEdit}
        className="btn-warning"
        iconOnly={true}
        title="Edit"
      >
        <FontAwesomeIcon icon={faPenToSquare} />
      </Button>
    </EditControls>
  );
  
  return (
    <VirtualizedTable
      data={users}
      columns={[
        {
          id: 'Controls',
          Header: 'Controls',
          accessor: 'userId',
          Cell: renderControlCell,
          ...fixedColumnStyle(100),
        },
        {
          id: 'firstName',
          Header: 'firstName',
          accessor: 'firstName',
          Filter: TextFilter,
          sortable: true,
        },
        {
          id: 'lastName',
          Header: 'lastName',
          accessor: 'lastName',
          Filter: TextFilter,
          sortable: true,
        },
        {
          id: 'email',
          Header: 'Email',
          accessor: 'email',
          Filter: TextFilter,
          sortable: true,
        },
        {
          id: 'gender',
          Header: 'Gender',
          accessor: 'gender',
          Filter: TextFilter,
          sortable: true,
        },
        {
          id: 'phone',
          Header: 'Phone',
          accessor: 'phone',
          Filter: TextFilter,
          sortable: true,
        },
        {
          id: 'linkedInUrl',
          Header: 'LinkedIn',
          accessor: 'linkedInUrl',
          Filter: TextFilter,
          sortable: true,
        },
        ...techStackColumns,
        {
          id: 'accountNonExpired',
          Header: 'Account Non Expired',
          accessor: 'accountNonExpired',
          Cell: BooleanCell,
          Filter: BooleanCheckboxFilter,
          sortable: true,
        },
        {
          id: 'accountNonLocked',
          Header: 'Account Non Locked',
          accessor: 'accountNonLocked',
          Cell: BooleanCell,
          Filter: BooleanCheckboxFilter,
          sortable: true,
        },
        {
          id: 'credentialsNonExpired',
          Header: 'Credential Non Expired',
          accessor: 'credentialsNonExpired',
          Cell: BooleanCell,
          Filter: BooleanCheckboxFilter,
          sortable: true,
        },
        {
          id: 'enabled',
          Header: 'Enabled',
          accessor: 'enabled',
          Cell: BooleanCell,
          Filter: BooleanCheckboxFilter,
          sortable: true,
        },
        {
          id: 'mfa',
          Header: 'MFA',
          accessor: 'mfa',
          // Filter: TextFilter,
          Cell: BooleanCell,
          Filter: BooleanCheckboxFilter,
          sortable: true,
        },
        {
          id: 'lastLogin',
          Header: 'Last Login',
          accessor: 'lastLogin',
          Cell: DateCell,
          Filter: TextFilter,
          sortable: true,
        },
        {
          id: 'createdAt',
          Header: 'Created At',
          accessor: 'createdAt',
          Cell: DateCell,
          Filter: TextFilter,
          sortable: true,
        },
        {
          id: 'updatedAt',
          Header: 'Updated At',
          accessor: 'updatedAt',
          Cell: DateCell,
          Filter: TextFilter,
          sortable: true,
        },
      ]}
    />
  );
}
